export default "__VITE_ASSET__BUEoRf18__"